import { Navigate } from "react-router-dom";
import { SignOutButton } from "@clerk/react";
import { Button } from "@/components/ui/button";
import { useMe } from "@/lib/useMe";

const Notice = ({ title, text, testId = "archived-notice" }) => (
  <div className="min-h-screen grid place-items-center p-6 bg-slate-50" data-testid={testId}>
    <div className="max-w-sm text-center rounded-2xl border border-slate-200 bg-white p-8">
      <h1 className="text-xl font-bold" style={{ fontFamily: "Outfit" }}>{title}</h1>
      <p className="mt-2 text-sm text-slate-600">{text}</p>
      <SignOutButton>
        <Button className="mt-6 bg-[#002FA7] hover:bg-[#001A75]" data-testid="archived-sign-out-btn">Sign out</Button>
      </SignOutButton>
    </div>
  </div>
);

const ArchivedNotice = () => <Notice title="Account archived" text="Your driver account is no longer active. Contact your dispatcher if this is a mistake." />;

export default function RoleGate({ expected, children }) {
  const { me, loading } = useMe();
  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center text-slate-500" data-testid="role-gate-loading">
        Loading…
      </div>
    );
  }
  if (!me) return <Navigate to="/sign-in" replace />;
  if (expected === "owner") return me.is_owner ? children : <Navigate to="/" replace />;
  if (me.workspace_status === "none") return <Notice testId="no-workspace-notice" title="No workspace yet" text="Your login isn't linked to a carrier yet. Ask your carrier's admin to add you." />;
  if (me.workspace_status !== "active") return <Notice testId="deactivated-notice" title="Carrier account deactivated" text="This carrier's account is currently deactivated. Contact the platform owner." />;
  if (me.archived) return <ArchivedNotice />;
  if (me.role !== expected) {
    return <Navigate to={me.role === "admin" ? "/admin" : "/driver"} replace />;
  }
  return children;
}
